var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "rate-fraud-free-banner overflow-hidden pa-6" },
    [
      _c("span", {
        staticClass: "rate-fraud-free-banner__overlay",
        attrs: { "aria-hidden": "false" },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass:
            "d-inline-flex flex-wrap gc-1 position-relative d-flex text-h6 bg-gray-0--text",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.t(
                  "Сообщите о заказном отзыве на сайте ПроДокторов",
                  _setup.options
                )
              ) +
              "\n    "
          ),
          _c("span", { staticClass: "text-no-wrap" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  `${_setup.t("и получите до", _setup.options)} ${
                    _vm.cashReward
                  }`
                ) +
                "\n    "
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }